import { render, staticRenderFns } from "./DetailArtikel.vue?vue&type=template&id=47de3442&"
import script from "./DetailArtikel.vue?vue&type=script&lang=js&"
export * from "./DetailArtikel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports